import React from 'react';

interface ControlBarProps {
  visible: boolean;
  isVideo: boolean;
  children: React.ReactNode;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
}

export function ControlBar({ visible, isVideo, children, onMouseEnter, onMouseLeave }: ControlBarProps) {
  return (
    <div
      className={`kollab-player-controls ${visible ? '' : 'kollab-player-controls--hidden'}`}
      role="toolbar"
      aria-label={isVideo ? 'Video controls' : 'Audio controls'}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      {children}
    </div>
  );
}
